<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Area Page</h2>

</div>
